import formsReducer, {
  disableForm,
  enableForm,
  clearForm,
  setFormErrors
} from "../lib/formsReducer";
import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import { Record, Map } from "immutable";
import { isApiCall } from "../app/schema";

import Pages from "./pages";

const feature = "pages";

const InitialState = Record({
  pages: new Pages()
});

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function PagesReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload && action.payload.entities && action.payload.entities.pages
    ) {
      state = state.updateIn(["pages", "entities"], map =>
        map.mergeDeep(action.payload.entities.pages));
    }
  }

  switch (action.type) {
    case actions.GET_PAGES: {
      return state.setIn(["pages", "loading"], true);
    }
    case actions.GET_PAGES_SUCCESS: {
      state = state.deleteIn(["pages", "entities"]);
      state = state.deleteIn(["pages", "results"]);
      state = state.setIn(
        ["pages", "meta", "all"],
        action.payload.result.meta.all
      );
      state = state.setIn(
        ["pages", "meta", "count"],
        action.payload.result.meta.count
      );
      state = state.updateIn(["pages", "entities"], map =>
        map.mergeDeep(action.payload.entities.pages));
      state = state.setIn(["pages", "results"], action.payload.result.pages);
      return state.setIn(["pages", "loading"], false);
    }
    case actions.GET_PAGES_ERROR: {
      return state.setIn(["pages", "loading"], false);
    }

    case actions.PATCH_PAGE: {
      return state.setIn(["pages", "loading"], true);
    }
    case actions.PATCH_PAGE_SUCCESS: {
      return state.setIn(["pages", "loading"], false);
    }
    case actions.PATCH_PAGE_ERROR: {
      return state.setIn(["pages", "loading"], false);
    }

    case actions.DELETE_PAGE: {
      return state.deleteIn(["pages", "entities", action.payload.uid]);
    }

  }

  return entitiesReducer(formsReducer(state, feature, action), feature, action);
}



// WEBPACK FOOTER //
// ./src/common/pages/reducer.js